<template>
  <div>
    <file-library
      :allowedFiles="'audio'"
      :key="selectedFile.id"
      ref="fileLibrary"
      :value="selectedFile"
      @selected="
        updateItem({
          title: $event.name,
          value: JSON.stringify($event),
          description: '<p>Some Description</p>',
        })
      "
      @opened="fileLibraryOpened"
      @closed="fileLibraryClosed"
    />
    <div class="section-paragraph space-y-5">
      <div v-for="(file, index) in list" :key="index" class="space-y-5">
        <div class="w-full">
          <audio
            class="w-50 shadow border rounded-full"
            controls
            controlsList="nodownload"
          >
            <source :src="JSON.parse(file.value).public_path" />
          </audio>
          <div
            v-if="!isPreview"
            class="text-grey-500 cursor-pointer absolute right-5 -mt-8"
            @click.stop="deleteItem(index)"
          >
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div v-if="!isPreview">
          <quill-editor
            :value="file.description"
            :options="getQuillEditorOptions('section-paragraph')"
            @change="updateDescription(index, $event, 'description')"
            @ready="onEditorReady($event)"
          ></quill-editor>
        </div>
        <div v-else v-html="file.description"></div>
      </div>
      <div
        v-if="!isPreview"
        @click="openAddItemPopup()"
        class="text-pink md:text-xl text-base font-semibold cursor-pointer"
      >
        + Add Audio
      </div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import quillMixin from '../../../mixins/quill';
import FileLibraryMixin from '../custom-popup/file-library/mixin';

export default {
  name: 'Audio',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    index: {},
    getThemeSettings: {},
    content: {
      type: Object,
      required: true,
    },
  },
  mixins: [quillMixin, FileLibraryMixin],
  computed: {
    list() {
      return this.content.items;
    },
  },
  methods: {
    updateItem(item) {
      try {
        const items = cloneDeep(this.list);
        this.editingItemIndex < 0
          ? items.push(item)
          : (items[this.editingItemIndex] = item);

        this.$emit('updateSectionContent', {
          items,
        });
      } catch (err) {
        /** */
      }
    },
    updateDescription(index, { html }, key) {
      const items = cloneDeep(this.list);

      items[index][key] = html;

      this.$emit('updateSectionContent', { items });
    },
    deleteItem(index) {
      const items = cloneDeep(this.list);
      items.splice(index, 1);

      this.$emit('updateSectionContent', { items });
    },
  },
};
</script>
<style lang="scss">
</style>
